<template>
  <va-card class="flex mb-4">
    <va-card-title style="height: 30px;padding:5px;padding-left:20px ">数据字典</va-card-title>
    <va-card-content>
      <a-tabs v-model:activeKey="activeKey" tab-position="top" animated type="card">
        <a-tab-pane key="1" tab="总部维护">
          <Headquarter></Headquarter>
        </a-tab-pane>
        <a-tab-pane key="2" tab="总部窗口">
          <HeadquarterWin></HeadquarterWin>
        </a-tab-pane>
        <a-tab-pane key="3" tab="场景组成员">
          <SceneMember></SceneMember>
        </a-tab-pane>
        <a-tab-pane key="4" tab="技术组成员">
          <TechMember></TechMember>
        </a-tab-pane>
        <a-tab-pane key="5" tab="数字员工类型">
          <DigitalMemberType></DigitalMemberType>
        </a-tab-pane>
        <a-tab-pane key="6" tab="部署平台维护">
          <DeployPlatform></DeployPlatform>
        </a-tab-pane>
        <a-tab-pane key="7" tab="推进办公室管理员">
          <AdanceOfficeAdmin></AdanceOfficeAdmin>
        </a-tab-pane>
        <a-tab-pane key="8" tab="安全审核员">
          <SecurityReviewer></SecurityReviewer>
        </a-tab-pane>
        <a-tab-pane v-if="$store.state.isAdmin === '1'" key="10" tab="Skill 超级管理员">
          <SkillSuperAdmin></SkillSuperAdmin>
        </a-tab-pane>
        <a-tab-pane key="9" tab="目标维护">
          <YearGoals></YearGoals>
        </a-tab-pane>
      </a-tabs>
    </va-card-content>
  </va-card>

</template>

<script>
import Qs from 'qs'
import {reactive, ref} from 'vue'
import {VXETable, VxeTableInstance, VxeTablePropTypes} from 'vxe-table'
import XEUtils from 'xe-utils'
import Headquarter from './Headquarter.vue'
import HeadquarterWin from './HeadquarterWin.vue'
import AdanceOfficeAdmin from './AdanceOfficeAdmin.vue'
import DeployPlatform from './DeployPlatform.vue'
import DigitalMemberType from "./DigitalMemberType.vue";
import SceneMember from "./SceneMember.vue";
import TechMember from "./TechMember.vue";
import YearGoals from "./YearGoals.vue";
import SecurityReviewer from "./SecurityReviewer.vue";
import SkillSuperAdmin from "./SkillSuperAdmin.vue";


export default {
  name: "DigitalDictList",
  components: {
    Headquarter,
    HeadquarterWin,
    AdanceOfficeAdmin,
    DeployPlatform,
    DigitalMemberType,
    SceneMember,
    TechMember,
    YearGoals,
    SecurityReviewer,
    SkillSuperAdmin
  },
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: '',
        searchStatus: ''
      }
    })
    const formInput = reactive({
      isShow: false,
      formData: {
        Id: '',
        processName: '',
        processDesc: '',
        bussName: '',
        divison: '',
        status: '',
        dept: '',
        office: '',
        bussEmail: '',
        manSingleTime: '',
        participantNum: '',
        manFrequency: '',
        selfLevel: '2',//优先级自判 中
        requireNo: '',
        winMan: '',
        winManUID: '',
        leader: '',
        leaderUID: '',
        timeRequire: '',
        pddPlanFinishTime: '',
        devPlanFinishTime: '',
        devDifficulty: '1',
        developer: '',
        developerMail: '',
        rejectButDisable: false,
        approveBtnDisable: false,
        newStepBtnDisable: false,
        delStepBtnDisable: false
      },
      formRules: {
        requireNo: [
          {required: false, message: '需求编号不能为空'},
        ],
        processName: [
          {required: true, message: '请输入流程名称'}
        ],
        processDesc: [
          {required: true, message: '请输入流程描述'}
        ],
        bussName: [
          {required: true, message: '请输入姓名'}
        ],
        divison: [
          {required: true, message: '请输入总部'}
        ],
        dept: [
          {required: true, message: '请输入部门'}
        ],
        office: [
          {required: true, message: '请输入科室'}
        ],
        bussEmail: [
          {required: true, message: '请输入邮箱'}
        ],
        manSingleTime: [
          {required: true, message: '请输入人工单次耗时'}
        ],
        participantNum: [
          {required: true, message: '请输入人工单次参与人数'}
        ],
        manFrequency: [
          {required: true, message: '请输入人工执行频次'}
        ],
        selfLevel: [
          {required: true, message: '请选择优先级自判'}
        ],
        winMan: [
          {required: true, message: '请选择窗口人'}
        ],
        leader: [
          {required: true, message: '请选择科长'}
        ],
        timeRequire: [
          {required: false, message: '请输入时间要求'}
        ],
        pddPlanFinishTime: [
          {required: true, message: '请选择PDD计划完成时间'}
        ],
        devPlanFinishTime: [
          {required: true, message: '请选择开发计划完成时间'}
        ],
        devDifficulty: [
          {required: true, message: '请选择开发难度'}
        ],
      },
      stepsData: []
    })
    const activeKey = ref('1')

    return {
      tableData: null,
      tablePager,
      toolbar,
      formInput,
      formDisable: true,
      isShowAuditList: false,
      dtAudit: null,
      isShowEditRow: false,
      isShowSaveBtn: false,
      iShowSelectUser: false,
      formTitle: '查看需求',
      pageHeight,
      cancelInfo: '', //需求取消原因
      isCancelInput: false,
      activeKey,
      tempDisable: true
    }
  },
  methods: {
    selectUser(type) {
      this.selectType = type;
      this.toolbar.formData.searchKey = '';
      this.findUserData();
      this.iShowSelectUser = true;
    },
    confirmSelectUser() {
      const $table = this.$refs.xTableUser;
      const record = $table.getCurrentRecord();
      if (record == null) {
        VXETable.modal.message({content: '请选择一行数据', status: 'info'});
        return;
      }
      //1 选择窗口 2 选择科长 3 开发人员
      if (this.selectType == '1') {
        this.formInput.formData.winMan = record.UserName;
        this.formInput.formData.winManUID = record.uid;
      } else if (this.selectType == '2') {
        this.formInput.formData.leader = record.UserName;
        this.formInput.formData.leaderUID = record.uid;
      } else {
        this.formInput.formData.developer = record.UserName;
        this.formInput.formData.developerMail = record.UserMail;
      }

      this.iShowSelectUser = false;
    },
    findUserData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.systemManageAPI.getUserList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.dtUser = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    launchToast(toastMsg) {
      this.$vaToast.init({
        message: toastMsg,
        iconClass: this.toastIcon,
        position: this.toastPosition,
        duration: Number(this.toastDuration),
        fullWidth: this.isToastFullWidth,
      })
    },
    //管理员修改
    editEvent(row) {
      this.isShowSaveBtn = true;
      this.isCancelInput = true;
      this.cancelInfo = '';
      this.formTitle = '修改需求';
      const params = {
        'uid': this.getUserUID,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.Id]
      };
      this.$api.requireManageAPI.getRequireOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.formData = res.data.Data.dataTable[0];
          //取操作步骤
          this.$api.requireManageAPI.getRequireSteps(Qs.stringify(params))
            .then(res => {
              this.formInput.stepsData = res.data.Data.dataTable;
              this.formDisable = false;
              this.formInput.isShow = true;
            })
            .catch(error => {
              console.log(error);
            })

        })
        .catch(error => {
          console.log(error);

        })
    },
    async removeReqRowEvent(row) {

      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.xTable1
      if (type === 'confirm') {

        this.$api.requireManageAPI.deleteRequires(Qs.stringify({"reqId": row.Id}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});

            $grid.remove(row);
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    addAuditRecord(status, info) {
      //写审核日志
      const params = {
        'auditBuId': this.formInput.formData.Id,
        'auditMan': this.$store.state.userName,
        'auditManUid': this.$store.state.userID,
        'auditStatus': status,//0发起 1 通过 2 驳回 3 取消
        'auditOpinion': this.cancelInfo,
        'auditNode': '需求取消'
      };
      this.$api.requireManageAPI.addAuditRecord(Qs.stringify(params))
        .then(res => {
          if (res.data.Success === false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }

        })
        .catch(error => {
          console.log(error);
        })
    },
    showEvent(row) {
      this.isShowSaveBtn = false;
      this.formTitle = '查看需求';
      this.isCancelInput = false;
      this.cancelInfo = '';
      const params = {
        'uid': this.getUserUID,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.Id]
      };
      this.$api.requireManageAPI.getRequireOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.formData = res.data.Data.dataTable[0];
          //取操作步骤
          this.$api.requireManageAPI.getRequireSteps(Qs.stringify(params))
            .then(res => {
              this.formInput.stepsData = res.data.Data.dataTable;
              this.formDisable = true;
              this.formInput.isShow = true;
            })
            .catch(error => {
              console.log(error);
            })

        })
        .catch(error => {
          console.log(error);

        })
    },
    findData() {
      const findStat = this.isAdmin() ? '2' : '3';//2 全部数据 3 按审核日志查
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey, findStat, this.toolbar.formData.searchStatus] //按审核记录查
      };
      this.$api.requireManageAPI.getRequireList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            VXETable.modal.message({content: res.data.Message, status: 'error'});

            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
    clear() {
      this.toolbar.formData.searchKey = '';
      this.toolbar.formData.searchStatus = '';
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
    exportDataEvent() {
      const $table = this.$refs.xTable1;
      $table.exportData({type: 'csv'})
    },
    async importDataEvent() {
      const {files} = await VXETable.readFile(false)
      if (files == null || files.length == 0) {
        return;
      }
      const data = new FormData();
      data.append('file', files[0]);
      this.$api.requireManageAPI.importRequires(data)
        .then(res2 => {
          if (res2.data.Success == false) {
            VXETable.modal.message({content: res2.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({content: '导入成功', status: 'success'});

          this.findData();
        })
        .catch(error2 => {
          VXETable.modal.alert({content: error2, status: 'error'});
          console.log(error2);
        });
    },
    formatTime({cellValue, row, column}) {
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
    },
    showAuditList(row) {

      const params = {
        'uid': this.getUserUID,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 1,
        'searchKey': [row.Id] //
      };
      this.$api.requireManageAPI.getAuditRecordList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.dtAudit = res.data.Data;

          this.isShowAuditList = true;
        })
        .catch(error => {
          console.log(error);

        })

    },
    isAdmin() {
      return this.$store.state.isAdmin === '1';
    },
    //保存新需求
    save() {
      if (this.formInput.formData.processName === '') {
        VXETable.modal.message({content: '流程名称不能为空', status: 'warning'});
        return;
      }
      const params = this.formInput.formData;

      this.$api.requireManageAPI.updateRequiresAdmin(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({content: '保存成功', status: 'success'});
          this.formInput.isShow = false;
          this.findData();
        })
        .catch(error => {
          VXETable.modal.message({content: error, status: 'error'});
          console.log(error);
        });

    },
    async retire() {

      const type = await VXETable.modal.confirm('您确定要取消该需求?')
      if (type === 'confirm') {
        if (this.formInput.formData.processName === '') {
          VXETable.modal.message({content: '流程名称不能为空', status: 'warning'});
          return;
        }
        if (this.cancelInfo === '') {
          VXETable.modal.message({content: '需求取消原因不能为空', status: 'warning'});
          return;
        }
        const params = this.formInput.formData;

        this.$api.requireManageAPI.updateRequiresRetire(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '需求取消成功', status: 'success'});

            this.addAuditRecord(3);

            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    calManYear() {
      if (this.formInput.formData.manSingleTime && this.formInput.formData.manFrequency && this.formInput.formData.participantNum) {
        this.formInput.formData.manYear = this.formInput.formData.manSingleTime * this.formInput.formData.manFrequency * this.formInput.formData.participantNum * 12;

      }
    }
  },
  created() {
    this.isShowEditRow = this.$store.state.isAdmin === '1'
  },
  mounted() {

    ///  this.findData();
    // window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getUserUID() {
      return this.$store.state.userID;
    },
    getUserEmail() {
      return this.$store.state.email;
    },

  }
}
</script>
<style src="@/pages/admin/forum/css/antd.css"></style>
<style type="text/css">
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab {
  text-align: left !important;
}
</style>
